<template>
  <div class="container">
    <router-view></router-view>
    <div class="cross-wrapper" v-if="showCross">
      <i
        class="iconfont acog-guanbi cross"
        @click="$router.push({path:'/about-us/brands'})"
      ></i>
    </div>
  </div>
</template>
<script>
export default {
  computed:{
    showCross(){
      return /^\/about-us\/brands\/[0-9]{1,2}$/.test(this.$route.path)
    }
  },
  methods: {
    onItemClick(index) {
      if (index === 6 || index === 9) {
        return;
      }
      this.current = index;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  .cross-wrapper{
    position: absolute;
    width: 1200px;
    top: 30px;
    text-align: right;
    left: 50%;
    transform: translateX(-50%)
  }
  .cross {
      color: #f7be91;
      font-size: 24px;
      cursor: pointer;
    }
}
</style>